import type { Group } from 'fhir/r4';
import * as yup from 'yup';
import { GroupCode, GroupSecurity } from '../coding';
import type { ResourceType } from '../types';
import { createCodeableConceptSchema } from './coding';
import { createMultipleReferenceValidationSchema } from './reference';
import type { Validated } from './types';

type RequiredField = 'type' | 'actual' | 'resourceType';
export type ValidatedGroup = Validated<Group, RequiredField>;

const resourceTypeSchema = yup.string().equals(['Group']).required();
const activeSchema = yup.boolean().required();
const actualSchema = yup.boolean().required();
const nameSchema = yup.string().required().min(1);
const types: Group['type'][] = [
  'person',
  'animal',
  'device',
  'medication',
  'practitioner',
  'substance',
];
const typeSchema = yup.string().oneOf(types).required();
const groupSecurityCodes = Object.values(GroupSecurity);
const groupTypeCodes = Object.values(GroupCode);
const codeSchema = createCodeableConceptSchema([
  ...groupSecurityCodes,
  ...groupTypeCodes,
]);

/**
 * Schema to be used when an `Group` is created
 */
export const groupCreationSchema = yup
  .object({
    active: activeSchema,
    actual: actualSchema,
    resourceType: resourceTypeSchema,
    code: codeSchema,
    name: nameSchema,
    type: typeSchema,
    member: yup.object().is([undefined]), // .default(undefined),
  })
  .required();

/**
 * Schema to be used when an `Group` is created
 */
export const groupUpdateSchema = yup
  .object({
    active: activeSchema,
    actual: actualSchema,
    resourceType: resourceTypeSchema,
    code: codeSchema,
    name: nameSchema,
    type: typeSchema,
    member: yup.object().is([undefined]),
  })
  .required();

const allowedResourceTypes: ResourceType[] = [
  'Practitioner',
  'Patient',
  'PractitionerRole',
  'Device',
  'Medication',
  'Substance',
  'Group',
];
export const groupUpdateMemberSchema = yup.array(
  yup.object({
    entity: createMultipleReferenceValidationSchema(allowedResourceTypes),
    inactive: yup.boolean().required(),
  }),
);
